import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Utility function to create a slice and thunks dynamically
export const createApiSlice = (sliceName, apiConfig, customReducers = {}) => {
  const thunks = {};
  const extraReducers = {};

  // Generate thunks and extra reducers dynamically
  apiConfig.forEach(
    ({
      name,
      method,
      url,
      stateKey,
      loadingKey,
      isFileDownload,
      fileName,
      alertData,
    }) => {
      const thunk = createAsyncThunk(
        `${sliceName}/${name}`,
        async (data, { rejectWithValue, dispatch }) => {
          //  let checkMethod= method === "upload" ? "post" : method
          //  console.log("data123 ",data, )
          //  console.log("data?.get ",data?.get("params"), )
          try {
            const response = await axios({
              method,
              url,
              data: method === "get" ? undefined : data,
              params: method === "get" ? data : undefined,
              withCredentials: true,
              // added this new condition for handling the file download
              responseType: isFileDownload ? "blob" : "json",
            });
            resetFunction(dispatch, slice.actions);
            // added this new condition for handling the file download
            if (isFileDownload) {
              const blob = new Blob([response.data]);
              const url = globalThis.URL.createObjectURL(blob);

              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", fileName);
              document.body.appendChild(link);
              link.click();
              link.remove();

              return; // no redux state update needed
            }
            return response.data;
          } catch (err) {
            // Call reset function after failed API call
            resetFunction(dispatch, slice.actions);
            return rejectWithValue(err.response?.data);
          }
        },
      );

      thunks[name] = thunk;

      // Define the reducer functions
      extraReducers[thunk.pending] = (state) => {

        // custom loading key if provided
        if (loadingKey) {
          state[loadingKey] = true;
        } else {
          state.loading = true;
        }
      };
      extraReducers[thunk.fulfilled] = (state, action) => {
        // Reset custom loading key if provided
        if (loadingKey) {
          state[loadingKey] = false;
        } else {
          state.loading = false;
        }
        // added this new condition for handling the file download
        if (isFileDownload) return;
        if (stateKey === "message") {
          state.message = action.payload?.message ?? "";
        } else {
          state[stateKey] = action.payload ?? [];
        }
      };
      extraReducers[thunk.rejected] = (state, action) => {
        //   console.log("action", action);
        // console.log("alertDataCondition",alertData)
        // console.log(`Rejected action for ${name}`, action.payload);
        // Reset custom loading key if provided
        if (loadingKey) {
          state[loadingKey] = false;
        } else {
          state.loading = false;
        }
        // if there is any alertData needs to display so send the alertData key with true and then set the data
        // after rejection
        if (alertData) {
          state[stateKey] = action.payload ?? [];
        }
        // Reset the data if the API throws an error
        else if (stateKey !== "message") {
          state[stateKey] = [];
        }

        state.errMessage = action.payload?.message ?? "";
      };
    },
  );

  // Create the slice using createSlice
  const slice = createSlice({
    name: sliceName,
    initialState: {
      loading: false,
      message: "",
      errMessage: "",
      data: [],
      mainData: [],
      ...customReducers.initialState, // Merge custom initial state
    },
    reducers: {
      resetMessage: (state) => {
        state.message = "";
      },
      resetErrMessage: (state) => {
        state.errMessage = "";
      },
      rowSelect: (state, action) => {
        state.selectedData =
          action.payload.length > 0 ? action.payload[0] : null;
      },
      ...customReducers.reducers, // Merge custom reducers
    },
    extraReducers: (builder) => {
      // Add cases dynamically for each thunk
      Object.entries(extraReducers).forEach(([actionType, reducer]) => {
        builder.addCase(actionType, reducer);
      });
      // Add custom extra reducers
      Object.entries(customReducers.extraReducers || {}).forEach(
        ([actionType, reducer]) => {
          builder.addCase(actionType, reducer);
        },
      );
    },
  });

  return {
    slice,
    thunks,
    actions: slice.actions,
  };
};

// Helper function to reset messages after API calls
const resetFunction = (dispatch, actions) => {
  setTimeout(() => {
    actions.resetMessage && dispatch(actions.resetMessage());
    actions.resetErrMessage && dispatch(actions.resetErrMessage());
  }, 2000); // 2000 milliseconds = 2 seconds
};
